import React, { useState } from "react";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    username: "",
    email: "",
    code: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmitStep1 = async () => {
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch("/api/request-reset", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: form.username, email: form.email })
      });
      const result = await res.json();
      if (result.success) {
        setStep(2);
        setMessage("✅ Verification code sent to your email or phone.");
      } else {
        setMessage("❌ " + result.error);
      }
    } catch {
      setMessage("❌ Server error.");
    }
    setLoading(false);
  };

  const handleSubmitStep2 = () => {
    if (!form.code || form.code.length !== 6) {
      setMessage("❌ Please enter the 6-digit verification code.");
    } else {
      setStep(3);
      setMessage("");
    }
  };

  const handleSubmitStep3 = async () => {
    setLoading(true);
    setMessage("");

    if (form.newPassword !== form.confirmPassword) {
      setMessage("❌ Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      const res = await fetch("/api/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: form.username,
          code: form.code,
          newPassword: form.newPassword
        })
      });
      const result = await res.json();
      if (result.success) {
        setMessage("✅ Password reset successful! You can now log in.");
        setStep(4); // show completion
      } else {
        setMessage("❌ " + result.error);
      }
    } catch {
      setMessage("❌ Server error.");
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: "400px", margin: "5rem auto", padding: "2rem", borderRadius: "12px", background: "#fff", boxShadow: "0 0 20px rgba(0,0,0,0.1)" }}>
      <h2 style={{ textAlign: "center", marginBottom: "1.5rem" }}>Forgot Password</h2>

      {step === 1 && (
        <>
          <input type="text" name="username" placeholder="Username" value={form.username} onChange={handleChange} style={inputStyle} />
          <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} style={inputStyle} />
          <button onClick={handleSubmitStep1} style={buttonStyle} disabled={loading}>
            {loading ? "Sending..." : "Send Code"}
          </button>
        </>
      )}

      {step === 2 && (
        <>
          <input type="text" name="code" placeholder="6-digit Code" value={form.code} onChange={handleChange} style={inputStyle} />
          <button onClick={handleSubmitStep2} style={buttonStyle}>
            Verify Code
          </button>
        </>
      )}

      {step === 3 && (
        <>
          <input type="password" name="newPassword" placeholder="New Password" value={form.newPassword} onChange={handleChange} style={inputStyle} />
          <input type="password" name="confirmPassword" placeholder="Confirm Password" value={form.confirmPassword} onChange={handleChange} style={inputStyle} />
          <button onClick={handleSubmitStep3} style={buttonStyle} disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </>
      )}

      {step === 4 && (
        <p style={{ textAlign: "center", color: "green", fontWeight: "bold" }}>
          🎉 Your password has been reset. <br /> <a href="/" style={{ color: "#007bff" }}>Return to Login</a>
        </p>
      )}

      {message && <p style={{ color: message.startsWith("✅") ? "green" : "red", marginTop: "1rem", textAlign: "center" }}>{message}</p>}
    </div>
  );
};

const inputStyle = {
  marginBottom: "1rem",
  width: "100%",
  padding: "0.75rem",
  fontSize: "1rem",
  border: "1px solid #ccc",
  borderRadius: "6px"
};

const buttonStyle = {
  backgroundColor: "#007bff",
  color: "#fff",
  width: "100%",
  padding: "0.75rem",
  fontSize: "1rem",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};

export default ForgotPassword;
